import React, { useState } from 'react'
import { Box } from 'pcln-design-system'
import { useRouter } from 'next/router'
import StyledHeading from '@/components/StyledHeading'
import MobileTabStrip from '@/components/MobileTabStrip/MobileTabStrip'
import { ProductType } from '@/types'
import getCurrentTab from '@/shared-utils/getCurrentTab'
import analytics from '@/shared-utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import useSeti from '@/hooks/useSeti'
import useHeadlineValues from './customHooks/useHeadlineValues'
import getProductCategoryMobile from './utils/getProductCategoryMobile'
import getProductCategoryMobileExperiment from './utils/getProductCategoryMobileExperiment'
import useFormatHotelHeadline from './customHooks/useFormatHotelHeadline'
import HeroMobile from '../Hotels/Hero/HeroMobile'

export default function SearchForm() {
  const { push, query, pathname } = useRouter()
  const currentTab = getCurrentTab(query)

  const [activeTabName, setActiveTabName] = useState(currentTab)

  const mobileValues = useHeadlineValues(currentTab)

  const isSetiNoHeadings = useSeti('MBL_HP_NO_HEADINGS') === 'VARIANT'
  const { hotelHeadline, setLocation } = useFormatHotelHeadline(
    mobileValues,
    isSetiNoHeadings
  )
  const getProductExperimentFunction = isSetiNoHeadings
    ? getProductCategoryMobileExperiment
    : getProductCategoryMobile

  const updatedMobileValues = {
    ...mobileValues,
    hotels: {
      ...mobileValues.hotels,
      mobileHeadline: hotelHeadline
    }
  }

  const [formState, setFormState] = useState(
    getProductExperimentFunction(currentTab, updatedMobileValues, setLocation)
  )

  const handleOnTabClick = (productType: ProductType) => {
    setActiveTabName(productType)
    push(
      {
        pathname,
        query: {
          ...query,
          tab: productType
        }
      },
      undefined,
      { shallow: true }
    )

    analytics.fireEvent({
      action: 'Tab',
      label: productType,
      category: ANALYTICS_CATEGORY_HOME
    })
    const selectedProductCategory = getProductExperimentFunction(
      productType,
      updatedMobileValues,
      setLocation
    )
    setFormState(selectedProductCategory)
  }

  return (
    <Box mb={4} mt={2} boxShadowSize="xl" rounded="round" borderRadius="2xl">
      <MobileTabStrip activeTab={activeTabName} onTabClick={handleOnTabClick} />
      {activeTabName === 'hotels' && <HeroMobile />}
      <Box px={3}>
        {formState.headline && (
          <StyledHeading
            tag="h1"
            color="text.heading"
            textStyle="heading3"
            text={formState.headline}
          />
        )}
        <Box mt={formState.headline ? 3 : 0}>{formState.component}</Box>
      </Box>
      <Box mt={3}>{formState.bumper}</Box>
    </Box>
  )
}
